import React, { useState, useEffect } from "react";
import quillonz_logo from "../../../assets/images/quillionz_app_logo.png";
import fliprotate from "../../../assets/images/fliprotate.png";
import Quilliquizesharemodal from "../../pages/QuilliQuiz/Quilliquizesharemodal";
import './FlipAnimation.css'; // Import the CSS file
import {sampleQulliQuiz} from '../../data/QuilliQuiz/QuilliQuizSample'
import LoadingOverlay from "../../components/overlays/LoadingOverlay";
import Tooltip from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";
import { useLocation } from "react-router-dom";

const QuilliQuize = ({ props }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [isFlipped, setIsFlipped] = useState(false);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [content, setContent] = useState("");
  const [allQuestions , setAllQuestions] = useState('');
  const [likes, setLikes] = useState([]);
  const [correct , setCorrect] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const storedQuestions = localStorage.getItem("reviewContentResponse");
    if (storedQuestions) {
      const questions = JSON.parse(storedQuestions);
      setLikes(new Array(questions.length).fill(null));
      setCorrect(new Array(questions.length).fill(null));
    }
  }, []);

  const QulliquizeTitle = localStorage.getItem('title');

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleFlip = () => {
    setIsFlipped(!isFlipped);
  };

  const handleSlideLeft = () => {
    console.log('left slide clicked!');
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(currentQuestionIndex - 1);
      // setIsFlipped(false);  // Reset flip state on slide
    }
  }

  const handleSlideRight = () => {
    console.log('right slide clicked!');
    if (currentQuestionIndex < allnewQuestions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
      // setIsFlipped(false);  // Reset flip state on slide
    }
  }

  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + '...';
    }
    return text;
  };

  // const whQuestionsforQuilliQuiz = location.state?.whQuestions;

  let stored = localStorage.getItem('quilliQuizData');
  let whQuestionsforQuilliQuiz = null;
  
  if (stored) {
    try {
      whQuestionsforQuilliQuiz = JSON.parse(stored);
    } catch (e) {
      console.error("Error parsing stored quiz data", e);
    }
  }
  
  const allnewQuestions = [
  ...(whQuestionsforQuilliQuiz?.response?.fib_questions || []).map(fib => ({
      index: fib.index,
      category: fib.category || fib.Category,
      answer: fib.answer || fib.Answer,
      question: fib.question || fib.Question,
      originalSentence: fib.originalSentence || null
    })),
  ...(whQuestionsforQuilliQuiz?.response?.true_false_questions || []).map(tf => ({
      index: tf.index,
      category: tf.category || tf.Category,
      answer: tf.answer || tf.Answer,
      question: tf.question || tf.Question,
      originalSentence: tf.originalSentence || null
    })),
  ...(whQuestionsforQuilliQuiz?.response?.mcqs_questions || []).map(mcq => ({
      index: mcq.index,
      category: mcq.category || mcq.Category,
      answer: mcq.answer || mcq.Answer,
      question: mcq.question || mcq.Question,
      originalSentence: mcq.originalSentence || null
    })),
  ...(whQuestionsforQuilliQuiz?.response?.wh_questions || []).map(wh => ({
      index: wh.index,
      category: wh.category,
      answer: wh.answer || wh.Answer,
      question: wh.question || wh.Question,
      originalSentence: wh.originalSentence || null
    })),
  ...(whQuestionsforQuilliQuiz?.response?.interpretive_questions || []).map(intques => ({
      index: intques.index,
      category: intques.category,
      answer: intques.answer || intques.Answer,
      question: intques.question || intques.Question,
      originalSentence: intques.originalSentence || null
    })),
  ];

  console.log("allnewQuestions :",allnewQuestions);
  const toggleLike = (e, action) => {
    console.log("action",action);
    e.preventDefault();
    setLikes(prevLikes => {
      const newLikes = [...prevLikes];
      if (action === 'like') {
        newLikes[currentQuestionIndex] = newLikes[currentQuestionIndex] === true ? null : true;
      } else if (action === 'dislike') {
        newLikes[currentQuestionIndex] = newLikes[currentQuestionIndex] === false ? null : false;
      }
      return newLikes;
    });
    // setIsFlipped(false);  // Reset flip state on slide
  };
  

  const toogleCorrect = (e , action) => {
    console.log("action",action);
    e.preventDefault();
    setCorrect(prevCorrect => {
      const newCorrect = [...prevCorrect];
      if(action === 'correct'){
        newCorrect[currentQuestionIndex]=newCorrect[currentQuestionIndex] === true ? null : true ;
      }else if (action === 'noCorrect'){
      newCorrect[currentQuestionIndex]=newCorrect[currentQuestionIndex] === false ? null : false;
      }
      return newCorrect;
    });
    // setIsFlipped(false);
  };

  useEffect(() => {
    if(currentQuestionIndex){
      console.log("currentQuestionIndex changed:", currentQuestionIndex);
    }
    setIsFlipped(false);
  }, [currentQuestionIndex]);

  const currentQuestion = allnewQuestions[currentQuestionIndex];

  const correctCount = correct.filter(item => item === true).length;
  console.log('correctCount',correctCount);
  const incorrectCount = correct.filter(item => item === false).length;
  console.log('incorrectCount',incorrectCount);

  return (
    <div className="relative overflow-visible">
      <Header
        QulliquizeTitle={QulliquizeTitle}
        toggleDropdown={toggleDropdown}
        showDropdown={showDropdown}
        truncateText={truncateText}
      />  
      <div className="bg-customBlue flex-grow h-full">
        <QuestionInfoBar currentQuestionIndex={currentQuestionIndex} totalQuestions={allnewQuestions} correctCount={correctCount} incorrectCount={incorrectCount}/>
        <QuestionSlider
          isFlipped={isFlipped}
          handleFlip={handleFlip}
          handleSlideLeft={handleSlideLeft}
          handleSlideRight={handleSlideRight}
          currentQuestion={currentQuestion}
          currentQuestionIndex={currentQuestionIndex}
          allnewQuestions={allnewQuestions}
          likes={likes}
          toggleLike={toggleLike}
          correct = {correct}
          toogleCorrect={toogleCorrect}
        />
        <Footer />
      </div>
    </div>
  );
};

const Header = ({ QulliquizeTitle, toggleDropdown, showDropdown , truncateText }) => (
  <div className="flex bg-customSlate pt-[-0.5rem] border-b-[1px] border-orange-500">
    <div className="flex items-center mt-[10px] mb-4 ml-3">
      <img src={quillonz_logo} alt="Logo" className="w-3/4" />
    </div>
    <div className="flex justify-center ml-[355px] mt-[20px] text-base text-white w-[170px]">
    {QulliquizeTitle ? 
      (<>
        <Tooltip
        title={QulliquizeTitle}
        arrow
        placement="top"
        TransitionComponent={Zoom}
        TransitionProps={{ timeout: 300 }}
        >
        {truncateText(QulliquizeTitle, 20)}
        </Tooltip>
        </>)
    : 'Title goes here'}
    </div>
    <div className="">
      <div className="ml-[505px] mr-[20px] mt-5 text-blue-500 text-lg relative z-10" onClick={toggleDropdown}>
        <i className="fa-solid fa-share-alt cursor-pointer"></i>
        {showDropdown && (
          <div className="absolute">
            <Quilliquizesharemodal />
          </div>
        )}
      </div>
    </div>
  </div>
);

const QuestionInfoBar = ({currentQuestionIndex , totalQuestions , correctCount , incorrectCount}) => (
  <div className="flex items-center justify-center">
    <div className="bg-customDarkBlue mx-auto rounded-bl-[20px] rounded-br-[20px] text-white text-lg pt-0 pb-0 px-6 mb-[8px] inline-block font-segoe-ui">
      <div className="grid grid-cols-3 items-center w-[196px]">
        <div className="p-[4px] mb-[5px] mt-[7px] text-base font-normal">Q {currentQuestionIndex + 1}/{totalQuestions.length}</div>
        <div className="pl-2">
          <i className="fa fa-check-circle text-green-500 text-lg mr-2"></i>
         {correctCount}
        </div>
        <div>
          <i className="fa-regular fa-circle-xmark text-red-800 text-lg mr-2"></i>
          {incorrectCount}
        </div>
      </div>
    </div>
  </div>
);

const QuestionSlider = ({ isFlipped, handleFlip, handleSlideLeft, handleSlideRight, currentQuestion ,currentQuestionIndex , allnewQuestions , likes, toggleLike , correct , toogleCorrect}) => (
  <div className="flex items-center bg-customBlue justify-center relative h-[400px]">
  {currentQuestionIndex > 0 && (
    <button onClick={handleSlideLeft}>
      <i className="fa-solid fa-arrow-left text-orange-500 text-2xl absolute left-0 ml-[15rem] cursor-pointer"></i>
    </button>
  )}
    <div className="flip-container contents" onClick={handleFlip}>
      <div id="carouselControls" className={`flipper ${isFlipped ? 'flip' : ''} transition ease-in-out duration-700`}>
        <div className="front transition ease-in-out duration-700">
          <QuestionCard content={currentQuestion.question || currentQuestion.Question} type="Question" isLiked={likes[currentQuestionIndex]} toggleLike={toggleLike} />
        </div>
        <div className="back transition ease-in-out duration-700">
          <QuestionCard content={currentQuestion.answer || currentQuestion.Answer} type="Answer" isCorrect = {correct[currentQuestionIndex]} toogleCorrect={toogleCorrect}/>
        </div>
      </div>
    </div>
    {currentQuestionIndex < allnewQuestions.length - 1 && (
      <button onClick={handleSlideRight}>
        <i className="fa fa-arrow-right text-orange-500 text-2xl absolute right-0 mr-[15rem] cursor-pointer"></i>
      </button>
    )}
  </div>
);

const QuestionCard = ({ content, type, isLiked, toggleLike ,isCorrect, toogleCorrect }) => (
  <div className="bg-white w-[100%] mx-auto pt-0 pb-0 px-6 mb-[8px] inline-block mt-[4px] border rounded-sm overflow-hidden transition ease-in-out duration-1000">
    <div className="flex justify-center mt-[8px]">{type}</div>
    <div className="h-[345px] overflow-y-auto px-4 py-6 text-center flex items-center justify-center">
    <p className="whitespace-pre-wrap break-words text-sm leading-relaxed">
    {content}
    </p>
      <div
        className="flex items-center text-black"
        style={{
          position: "absolute",
          bottom: 0,
          right: 0,
          left: 0,
          background: "#efefef",
          borderRadius: "20px 20px 0 0",
          width: "315px",
          margin: "18px auto",
          padding: "12px 0",
          boxShadow: "0 3px 18px #000",
          display: "flex",
          justifyContent: "start",
        }}
        onClick={(e) => e.stopPropagation()}   
      >
        <div className="flex items-center text-xs text-customBlue ml-[15px] font-serif">
          {type === "Question" ? "Do you like this Question?" : "Was your answer correct?"}
        </div>
        <div className="flex items-center ml-[25px] space-x-[40px] widget">
          {type === "Question" ? (
            <>
              <div className={`rounded-full border-2 ${isLiked == true ? 'border-green-600' : 'border-green-600'} p-[5px] ${isLiked == true ? 'bg-green-700' : 'bg-white text-green-700'} group cursor-pointer`} onClick={(e) => {e.stopPropagation(); toggleLike(e, 'like');}}>
                <i className={`fa-solid fa-thumbs-up text-2xl ${isLiked == true? 'text-white':'text-green-700'}`}></i>
              </div>
              <div className={`rounded-full border-2 ${isLiked === false ? 'border-red-700' : 'border-red-600 '} p-[5px] ${isLiked === false ? 'bg-red-700' : ''} group cursor-pointer`} onClick={(e) => {e.stopPropagation(); toggleLike(e, 'dislike');}}>
                <i className={`fa-solid fa-thumbs-down text-2xl ${isLiked === false ? 'text-red-700' : 'text-white'}`} style={{ transform: "scaleX(-1)" }}></i>
              </div>
            </>
          ) : (
            <div className={`flex items-center space-x-[40px]`}>
              <div className={`rounded-full border-1 ${isCorrect == true ? 'border-green-600' : 'border-green-600'} p-[4px] pt-[4.5px] pb-[3.5px] ${isCorrect == true ? 'bg-white text-green-700' : 'bg-green-700'} group cursor-pointer`} onClick={(e) => {e.stopPropagation(); toogleCorrect(e , 'correct');}}>
                <i className={`fa fa-check-circle text-[2rem] ${isCorrect == true ? 'text-white':'text-green-700'}`}></i>
              </div>
              <div className={`rounded-full border-1 ${isCorrect == false ? 'border-red-700' : 'border-red-700'} p-[5px] ${isCorrect == false ? ' bg-red-700' : 'bg-white'} group cursor-pointer`} onClick={(e) => {e.stopPropagation(); toogleCorrect(e , 'noCorrect');}}>
                <i className={`fa fa-times text-[2rem] w-[32px] h-[32px] ${isCorrect == false ? 'text-red-700 ':'text-white'}`}></i>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
);



const Footer = () => (
  <>
    <div className="flex justify-center text-sm text-white">
      <img src={fliprotate} alt="Logo" className="w-8 h-[20px] mr-[8px]" />
      <div className="italic text-custom-12px font-segoe-ui-semilight">
        Tap on card to view the answer
      </div>
    </div>
    <div className="bg-customBlue flex-grow w-auto h-[40px]">
      <div className="flex justify-center mt-3 text-customfootertext text-custom-18px">
        QuilliQuiz created with
        <a href="https://www.quillionz.com" target="_blank" className="text-white ml-[3px] text-custom-18px">Quillionz</a>
      </div>
    </div>
  </>
);

export default QuilliQuize;
